import React from "react";
import clsx from "clsx";

interface Truncate {
  children: string;
  className?: string;
}

export default function Truncate(props: Truncate) {
  const [showTooltip, setShowTooltip] = React.useState(false);
  const textRef = React.useRef<HTMLDivElement>(null);

  const checkTextTruncation = () => {
    const isTruncated =
      textRef.current &&
      textRef.current.scrollWidth > textRef.current.clientWidth;
    setShowTooltip(Boolean(isTruncated));
  };

  return (
    <div className="group relative transition-all delay-400">
      {showTooltip && (
        <div
          className={clsx(
            "text-xs float rounded whitespace-nowrap !z-100 cursor-default absolute invisible px-2 py-1.5",
            "bg-white flex-col text-left",
            "bottom-7 -right-2",
            {
              // style
              "group-hover:animate-tooltip-show ": showTooltip,
            }
          )}
          onClick={(e) => e.stopPropagation()}
        >
          {props.children}
        </div>
      )}
      <div
        className={`${props.className} truncate`}
        onMouseEnter={checkTextTruncation}
        ref={textRef}
      >
        {props.children}
      </div>
    </div>
  );
}
